module.exports = __webpack_public_path__ + "img/2025-0516-02-02.f106498a.png";